const ImageWidget = ({ url, maxWidth, maxHeight }) => {
  return (
    <div>
      <img src={url} alt="Image" style={{ maxWidth, maxHeight }} className="mb-0" />
    </div>
  );
};

export default ImageWidget;
